export const notificationsPerPageInitial = 20;
